import { Controller } from '@hotwired/stimulus';
import { emitter } from 'src/emitter';

export default class NotificationsBellController extends Controller {
  public static targets = ['notificationCount'];

  declare private notificationCountTarget: HTMLElement;

  public onNotificationEmit(data: unknown): void {
    const actualData = data as { count?: undefined | number };

    if (!actualData || actualData['count'] === undefined) {
      return;
    }
    this.notificationCountTarget.innerHTML = actualData['count'].toString();

    if (actualData['count'] === 0) {
      this.notificationCountTarget.style.display = 'none';
    } else {
      this.notificationCountTarget.style.display = 'block';
    }
  }

  public connect(): void {
    emitter.on('notification:read', this.onNotificationEmit.bind(this));
    emitter.on('notification:read_all', this.onNotificationEmit.bind(this));
  }
  public disconnect(): void {
    emitter.off('notification:read', this.onNotificationEmit);
    emitter.off('notification:read_all', this.onNotificationEmit);
  }
}
